<template>
  <div class="page-content">
    <div class="page-title">
      Our strategic objectives
      <br />
      A common and cross-cutting framework for action
    </div>
    <img src="@/assets/images/splan/ffb09de03bfb4e69999c451a85d0d01b_mergeImage.png" alt="" />
    <div class="text">
      Four interlinked and cross-cutting strategic objectives, corresponding to the challenges and
      opportunities of our time, and in line with the overall framework of the 2030 Agenda for
      Sustainable Development and other internationally agreed development goals, will provide the
      structure of this Medium-Term Strategy. They represent the Organization’s contribution to the
      resolution of major global issues within its specific mandate and across its fields of
      competence, through action where it has a unique comparative advantage.
      <br />
      These objectives will allow for synergies and multi-sectoral approaches throughout the
      Organization. They translate into a limited number of outcomes, which will constitute the
      basis for the first quadrennial Programme and Budget (2022-2025) (41 C/5) and the second
      quadrennial Programme and Budget (2026-2029) (43 C/5), reflecting the contribution of UNESCO
      in all the relevant areas of work. This strategic results framework provides a better view of
      the relationship between UNESCO’s quadrennial results and the Organization’s longer-term
      objectives and impact.
      <br />
      This new framework for action, designed to allow the Organization to provide an integrated
      response to complex issues, will, in the first quadrennium, and in order to reinforce
      synergies and common programming, in support of extensively united action, translate into a
      pooling of skills and resources in cross-cutting thematic areas, such as: scientific and
      environmental education; media and information literacy and digital competencies; artificial
      intelligence, digital ethics and innovation; learning for diversity; and indigenous knowledge,
      cultures and languages – in order to strengthen synergies and joint programming, in the
      service of in-depth unity of action.
      <br />
      Education is the most powerful catalytic force to advance the 2030 Agenda in its entirety. In
      the last decade leading to 2030, taking advantage of the technological innovations and
      developments which have the potential to improve access to education and to promote quality
      education and lifelong learning opportunities for all, building on increased international
      educational cooperation and learning mobility, and exploiting the role of education in poverty
      alleviation, UNESCO is positioned to strengthen the resilience of education systems and
      address the challenges brought by the COVID-19 pandemic, which has caused severe education
      disruption and exacerbation of existing inequalities.20Medium-Term Strategy 2022-2029
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .text {
    margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
}
</style>
